<script setup lang="ts">
// 把支付 codeUrl 渲成二维码（本地生成，不外发第三方）。
import { ref, watch, onMounted } from 'vue'
import QRCode from 'qrcode'

const props = withDefaults(defineProps<{ value: string; size?: number }>(), { size: 208 })
const dataUrl = ref('')
const failed = ref(false)

async function render() {
  if (!props.value) {
    dataUrl.value = ''
    return
  }
  try {
    dataUrl.value = await QRCode.toDataURL(props.value, {
      width: props.size,
      margin: 1,
      color: { dark: '#3a2e25', light: '#fbf6ee' },
    })
    failed.value = false
  } catch {
    failed.value = true
  }
}

onMounted(render)
watch(() => props.value, render)
</script>

<template>
  <div class="kt-qr" :style="{ width: size + 'px', height: size + 'px' }">
    <img v-if="dataUrl" :src="dataUrl" :width="size" :height="size" alt="支付二维码" />
    <span v-else-if="failed" class="kt-qr__fallback">二维码生成失败</span>
    <span v-else class="kt-qr__fallback">生成中…</span>
  </div>
</template>
